module.exports = __webpack_public_path__ + "static/media/light-theme-engine-overrun.883334bc.svg";